export default __webpack_public_path__ + "static/media/storagemonitors.6fcac59b.png";